/**
 * Created by tourn on 28.02.17.
 */

import {
  CHART_CONTROLLER_EXPANDED_SET,
  CHART_RESET,
  CHART_SET,
  CHART_SET_ONE_SERIES,
  CHART_SET_RANGE_VALUE,
} from "./chartActions";
import { addMinutes, subDays } from "date-fns";

export const START_OF_DATA_COLLECTION = new Date(2016, 0, 1);
// Returns a fresh defaults object. The range/maxRange xmax values are anchored
// to "now", so they must be recomputed on each call rather than frozen at
// module load — otherwise long-lived tabs and CHART_RESET resurrect the
// initial-page-load timestamp.
export const getDefaultState = () => ({
  //xmin, xmax show the left/right borders of the current viewport. The navigator borders are currently only stored in chart state
  range: {
    xmin: subDays(new Date(), 7).getTime(),
    xmax: addMinutes(new Date(), 10).getTime(),
  },
  //these limit the navigator (the zoom bar at the bottom)
  maxRange: {
    xmin: 0,
    xmax: addMinutes(new Date(), 10).getTime(),
  },

  displayFlags: false,
  displayManualFlags: true,
  interventionFilter: false,
  compare: false,

  slidingWindow: null, //how big the sliding window of the displayed livefeed is - in seconds
  refresh: 300, //the interval in which the feed should be refreshed - in seconds

  loaded: false,
  loading: false,
  displayShare: false,

  series: {
    // [key]: bool
  },

  expandedControllers: {},
});

export default function (state = getDefaultState(), action) {
  switch (action.type) {
    case CHART_CONTROLLER_EXPANDED_SET:
      return {
        ...state,
        expandedControllers: {
          ...state.expandedControllers,
          [action.controllerId]: action.state,
        },
      };
    case CHART_RESET:
      return getDefaultState();
    case CHART_SET:
      return {
        ...state,
        [action.key]: action.value,
      };
    case CHART_SET_RANGE_VALUE:
      return {
        ...state,
        range: {
          ...state.range,
          [action.key]: action.value,
          skipChart: false,
          reload: true,
        },
      };
    case CHART_SET_ONE_SERIES:
      let expandController = {};
      let range = state.range;
      if (action.visible) {
        const [controllerId] = action.key.split(":");
        expandController = {
          expandedControllers: {
            ...state.expandedControllers,
            [controllerId]: true,
          },
        };

        if (Object.keys(state.series).length === 0) {
          if (action.lastWeightTime) {
            range = {
              xmin: subDays(action.lastWeightTime, 7).getTime(),
              xmax: addMinutes(action.lastWeightTime, 10).getTime(),
            };
          }
        }
      }

      return {
        ...state,
        series: {
          ...state.series,
          [action.key]: action.visible,
        },
        ...expandController,
        range,
      };
    default:
      return state;
  }
}
